module.exports = __webpack_public_path__ + "img/case-datan.e0b68479.png";